import helpers from '../helpers';

const $scroller = document.querySelector('.scroller');
const $container = document.querySelector('[data-scroller-container]');

const getElement = () => $scroller;

const setPosition = (position) => {
	if (typeof position !== 'undefined') {
		$scroller.scrollTop = position;
	}
};

const getPosition = () => $scroller.scrollTop;

const scroll = () => {
	$container.scrollTop = getPosition();

	ScrollTrigger.update();
};

const setContainerScrollbarOffset = () => {
	$container.style.right = `${$scroller.scrollHeight > innerHeight ? helpers.getScrollbarWidth(true) : 0}px`;
};

const setHeight = (height) => {
	let $inner = $scroller.querySelector('div');

	let currentPosition = null;

	if ($inner === null) {
		$inner = document.createElement('div');

		$scroller.appendChild($inner);
	}

	if ($inner.scrollDistance) {
		currentPosition = getPosition() / $inner.scrollDistance;
	}

	$inner.style.height = `${height || $container.scrollHeight}px`;
	$inner.scrollDistance = $inner.clientHeight - innerHeight;

	setContainerScrollbarOffset();

	if (currentPosition) {
		setPosition(currentPosition * $inner.scrollDistance);
	}
};

const setScrollTriggerProxy = () => {
	ScrollTrigger.scrollerProxy($scroller, {
		scrollTop(value) {
			if (arguments.length) {
				$scroller.scrollTop = value;
			}

			return $scroller.scrollTop;
		},
		getBoundingClientRect() {
			return {
				top: 0,
				left: 0,
				width: innerWidth,
				height: innerHeight,
			};
		},
	});
};

const update = () => {
	if ($scroller === null) {
		return;
	}

	setHeight();
};

const resize = update;

const init = () => {
	if ($scroller === null) {
		return;
	}

	update();
	setScrollTriggerProxy();

	$scroller.addEventListener('scroll', scroll);
};

export default {
	init,
	resize,
	update,
	setHeight,
	getPosition,
	setPosition,
	getElement,
};
